 class SuggestService {

    GetContent() {

        let sugggestdata = window.__pt.sugggestdata;
        
        if (sugggestdata) {
            return sugggestdata;
        }

        return {

            message: "no-data",
            status: 404
        }
    }
}

export const SuggestServices = new SuggestService();